import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import DownloadIcon from '@heroicons/react/outline/DownloadIcon';
import EyeIcon from '@heroicons/react/outline/EyeIcon';
import XIcon from '@heroicons/react/outline/XIcon';
import clsx from 'clsx';
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip';
import { T } from '../../../i18n';
import { MediaModal, PREVIEW_SUPPORTED_EXTENSION, } from '../../../MediaModal';
import { icons } from '../icons';
import { AttachmentName } from './AttachmentName';
const staticProps = {
    spinnerStyles: { borderTopColor: 'transparent' },
};
const extensionIconMap = {
    jpeg: 'jpg',
    jfif: 'jpg',
    pptx: 'ppt',
};
export const getExtensionIconName = (extension) => {
    // For unknown file extensions apply "unknown" icon
    if (!extension) {
        return 'unknown';
    }
    // If we have a map for this file extension, show the mapped icon
    if (extensionIconMap[extension]) {
        return extensionIconMap[extension];
    }
    // Otherwise use the extension name as it is
    return extension;
};
export const hasPreview = (attachment) => {
    var _a;
    const extension = (_a = attachment === null || attachment === void 0 ? void 0 : attachment.extension) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    return PREVIEW_SUPPORTED_EXTENSION.includes(extension);
};
export const Attachments = ({ attachments, onAttachmentDelete, isReadOnly, }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const slides = attachments.filter(hasPreview);
    const onPreview = (attachment) => {
        setActiveIndex(slides.findIndex(slide => slide.id === attachment.id));
        setModalVisible(true);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { children: attachments.map(attachment => {
                    var _a;
                    const { id, name, downloadUrl, isLoading } = attachment;
                    const extension = (_a = attachment === null || attachment === void 0 ? void 0 : attachment.extension) === null || _a === void 0 ? void 0 : _a.toLowerCase();
                    const canBePreviewed = hasPreview(attachment);
                    const IconComponent = icons[getExtensionIconName(extension)] || icons.unknown;
                    return (_jsxs("div", { className: clsx('flex max-w-full overflow-hidden items-center justify-between space-s-3 bg-surface px-6 py-4 rounded-md border border-line-subdued mt-4 ignore-typography cursor-default', canBePreviewed && 'cursor-pointer'), onClick: () => {
                            if (!canBePreviewed) {
                                return;
                            }
                            onPreview(attachment);
                        }, children: [_jsx(IconComponent, { className: "flex-shrink-0", width: 36, height: 36 }, void 0), _jsx(AttachmentName, { ...attachment }, void 0), isReadOnly ? (_jsxs(_Fragment, { children: [canBePreviewed && (_jsxs(Tooltip, { children: [_jsx(Tooltip.Trigger, { children: _jsx(EyeIcon, { onClick: () => onPreview(attachment), className: "cursor-pointer x-6 h-6 text-content-subdued hover:text-content-hovered" }, void 0) }, void 0), _jsx(Tooltip.Panel, { children: _jsx(T, { id: "Generics.Preview.Verb", defaultMessage: "Preview" }, void 0) }, void 0)] }, void 0)), _jsxs(Tooltip, { children: [_jsx(Tooltip.Trigger, { children: _jsx("a", { href: downloadUrl, download: name, onClick: e => {
                                                        e.stopPropagation();
                                                    }, children: _jsx(DownloadIcon, { className: "cursor-pointer x-6 h-6 text-content-subdued hover:text-content-hovered" }, void 0) }, void 0) }, void 0), _jsx(Tooltip.Panel, { children: _jsx(T, { id: "Generics.Download", defaultMessage: "Download" }, void 0) }, void 0)] }, void 0)] }, void 0)) : (_jsxs(_Fragment, { children: [isLoading && (_jsx("div", { style: staticProps.spinnerStyles, className: "w-5 h-5 border border-focused rounded-full animate-spin" }, void 0)), _jsxs(Tooltip, { children: [_jsx(Tooltip.Trigger, { children: _jsx(XIcon, { onClick: e => {
                                                        e.stopPropagation();
                                                        onAttachmentDelete === null || onAttachmentDelete === void 0 ? void 0 : onAttachmentDelete(attachment);
                                                    }, className: " text-content-subdued hover:text-content-hovered cursor-pointer x-6 h-6" }, void 0) }, void 0), _jsx(Tooltip.Panel, { children: _jsx(T, { id: "Generics.Delete", defaultMessage: "Delete" }, void 0) }, void 0)] }, void 0)] }, void 0))] }, id));
                }) }, void 0), (slides === null || slides === void 0 ? void 0 : slides.length) > 0 && (_jsx(MediaModal, { slides: slides, isVisible: modalVisible, onClose: () => setModalVisible(false), activeMediaIndex: activeIndex }, void 0))] }, void 0));
};
//# sourceMappingURL=Attachments.js.map